import { CaptureSystemSensor } from "./capturesystemsensor";
import { isValidSchema } from "./util";
export class CaptureSystem {
    constructor(id, name, description, tooltip, tilt, projection, height, orientation, sensorgroup, sensors) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.tooltip = tooltip;
        this.tilt = tilt;
        this.projection = projection;
        this.height = height;
        this.orientation = orientation;
        this.sensors = sensors;
        this.sensorgroup = sensorgroup;
    }
    static create(payload) {
        const sensors = [];
        for (const sensor of payload.sensors) {
            sensors.push(CaptureSystemSensor.create(sensor));
        }
        return new CaptureSystem(payload.id, payload.name, payload.description, payload.tooltip, payload.tilt, payload.projection, payload.height, payload.orientation, payload.sensorgroup, sensors);
    }
    // FIXME: This needs to be replaced with something better. An existing validator tool.
    static isValid(payload) {
        const schema = [
            "id",
            "name",
            "description",
            "tooltip",
            "tilt",
            "projection",
            "height",
            "orientation",
            "sensors",
        ];
        const valid = isValidSchema(payload, schema);
        if (!valid) {
            return false;
        }
        for (const sensor of payload.sensors) {
            if (!CaptureSystemSensor.isValid(sensor)) {
                return false;
            }
        }
        return true;
    }
}
//# sourceMappingURL=capturesystem.js.map